import React from 'react';
import HookMachine from '../components/HookMachine';
import TestMarker from '../components/TestMarker';

export default function HookMachinePage() {
  return (
    <div className="min-h-screen bg-gray-950 py-8">
      <TestMarker />
      <HookMachine />
    </div>
  );
}